import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Calender, TextInputForm, DropDownUI } from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import axios from "axios";
import { useNavigate, Navigate } from "react-router-dom";
import { ClickButton, Delete } from "../components/Buttons";
import API_DOMAIN from "../config/config";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDeleteForever } from "react-icons/md";
import { db } from "../pages/indexedDB";

const alltax = [
  {
    value: "IGST@0%",
    label: "IGST@0%",
  },
  {
    value: "GST@0%",
    label: "GST@0%",
  },
  {
    value: "IGST@0.25%",
    label: "IGST@0.25%",
  },
  {
    value: "GST@0.25%",
    label: "GST@0.25%",
  },
  {
    value: "IGST@3%",
    label: "IGST@3%",
  },
  {
    value: "GST@3%",
    label: "GST@3%",
  },
  {
    value: "IGST@5%",
    label: "IGST@5%",
  },
  {
    value: "GST@5%",
    label: "GST@5%",
  },
  {
    value: "IGST@12%",
    label: "IGST@12%",
  },
  {
    value: "GST@12%",
    label: "GST@12%",
  },
  {
    value: "IGST@18%",
    label: "IGST@18%",
  },
  {
    value: "GST@18%",
    label: "GST@18%",
  },
  {
    value: "IGST@28%",
    label: "IGST@28%",
  },
  {
    value: "GST@28%",
    label: "GST@28%",
  },
];
const allovertax = [
  {
    value: "IGST@0%",
    label: "IGST@0%",
  },
  {
    value: "GST@0%",
    label: "GST@0%",
  },
  {
    value: "IGST@0.25%",
    label: "IGST@0.25%",
  },
  {
    value: "GST@0.25%",
    label: "GST@0.25%",
  },
  {
    value: "IGST@3%",
    label: "IGST@3%",
  },
  {
    value: "GST@3%",
    label: "GST@3%",
  },
  {
    value: "IGST@5%",
    label: "IGST@5%",
  },
  {
    value: "GST@5%",
    label: "GST@5%",
  },
  {
    value: "IGST@12%",
    label: "IGST@12%",
  },
  {
    value: "GST@12%",
    label: "GST@12%",
  },
  {
    value: "IGST@18%",
    label: "IGST@18%",
  },
  {
    value: "GST@18%",
    label: "GST@18%",
  },
  {
    value: "IGST@28%",
    label: "IGST@28%",
  },
  {
    value: "GST@28%",
    label: "GST@28%",
  },
];

const DropList = [
  {
    value: "DR",
    label: "DR",
  },
  {
    value: "CR",
    label: "CR",
  },
];

const WholesaleBillEntry = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [roundoff, setRoundoff] = useState(false);
  const [roundoffAmount, setRoundoffAmount] = useState(0);
  const [originalTotal, setOriginalTotal] = useState(null);
  const navigate = useNavigate();
  const [tax_type, settax_type] = useState("");

  const initialState =
    type === "edit"
      ? {
          ...rowData,
          product: rowData.products
            ? rowData.products.map((prod) => ({
                MarksNo: prod.MarksNo,
                product_id: prod.product_id,
                remark: prod.remark,
                product_name: prod.product_name,
                qty: prod.qty,
                unit: prod.unit,
                price_unit: prod.price_unit,
                discount_percentage: prod.discount_percentage,
                discount_amt: prod.discount_amt,
                hsn_no: prod.hsn_no,
                tax_type: prod.tax_type,
                tax_percentage: prod.tax_percentage,
                tax_amt: prod.tax_amt,
                total_amt: prod.total_amt,
                unit_name: prod.unit_name,
              }))
            : [],
        }
      : {
          party_id: "",
          partyname: "",
          partyaddress: "",
          placeofsupply: "",
          bill_no: "",
          bill_date: "",
          from: "",
          to: "",
          purchase_gst: "",
          receipt_number: "",
          transport_gst_no: "",
          purchasemobile_no: "",
          total: "",
          paid: "",
          balance_amount: "",
          final_total: "",
          discount_all: "",
          total_discountall: "",
          taxover_amt: "",
          taxover_percentage: "",
          roundoffAmount: "0.00",
          despatched_by: "",
          total_cases: "",
          globalGST: "",
          product: [
            {
              MarksNo: "",
              product_id: "",
              product_name: "",
              qty: "",
              unit: "",
              price_unit: "",
              discount_percentage: "",
              discount_amt: "",
              hsn_no: "",
              tax_type: "",
              tax_percentage: "",
              tax_amt: "",
              total_amt: "",
            },
          ],
        };

  const [formData, setFormData] = useState({
    ...initialState,
    bill_date: type === "edit" ? new Date(rowData.bill_date) : new Date(), // Handle bill_date for edit
  });
  //console.log(formData);
  const formatDateString = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const setLabel = (date, type) => {
    if (date instanceof Date && !isNaN(date)) {
      setFormData((prev) => ({
        ...prev,
        [type]: formatDateString(date),
      }));
    } else {
      console.error("Invalid date format received");
    }
  };

  const handleRoundoffChange = (e) => {
    const isChecked = e.target.checked;
    setRoundoff(isChecked);

    let final_total = parseFloat(formData.final_total) || 0;
    let roundedTotal = Math.round(final_total);
    let roundDiff = (roundedTotal - final_total).toFixed(2);

    if (isChecked) {
      if (originalTotal === null) {
        setOriginalTotal(final_total);
      }

      setFormData((prevData) => ({
        ...prevData,
        final_total: roundedTotal.toFixed(2),
        roundoffAmount: isNaN(roundDiff) ? "0.00" : roundDiff, // ✅ Ensure roundoff is always valid
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        final_total:
          originalTotal !== null
            ? originalTotal.toFixed(2)
            : prevData.final_total,
        roundoffAmount: "0.00", // ✅ Reset roundoff amount
      }));

      setOriginalTotal(null);
    }
  };

  const handleGlobalGST = (updatedFormData) => {
    if (!updatedFormData.globalGST) {
      console.error("globalGST is undefined or empty!");
      return;
    }

    const selectedTax = alltax.find(
      (tax) => tax.value === updatedFormData.globalGST
    );

    if (!selectedTax) {
      console.error("Invalid GST value selected:", updatedFormData.globalGST);
      return;
    }

    // Extract GST percentage from selected value
    const taxValueMatch = updatedFormData.globalGST.match(/\d+\.*\d*/);
    if (!taxValueMatch) {
      console.error("Invalid GST format:", updatedFormData.globalGST);
      return;
    }

    const taxValue = parseFloat(taxValueMatch[0]); // Convert GST to a number
    const taxType = selectedTax.value.split("@")[0];

    // Calculate GST Amount from Total
    const totalAmount = parseFloat(formData.total) || 0;
    const gstAmount = (totalAmount * taxValue) / 100;
    const subtotalWithGST = totalAmount + gstAmount;

    let updatedFormDataState = {
      ...formData,
      globalGST: updatedFormData.globalGST,
      taxover_amt: gstAmount.toFixed(2), // ✅ Save GST Amount
      final_total: subtotalWithGST.toFixed(2), // ✅ Save Subtotal with GST
      product: formData.product.map((row) => ({
        ...row,
        tax_percentage: updatedFormData.globalGST,
        tax_type: taxType,
      })),
    };

    setFormData(updatedFormDataState);
  };

  const handleAddRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      product: [
        ...prevState.product,
        {
          /* New product row */
        },
      ],
    }));
  };

  // Delete a row from the product list
  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      product: prevState.product.filter((_, i) => i !== index),
    }));
  };

  // Handle change in total amount
  const handleTotalChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      total: e.target.value,
    }));
  };

  // Handle change in paid amount
  const handlePaidChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      paid: e.target.value,
    }));
  };
  const calculateTotal = (product = []) => {
    const totalAmount = product.reduce(
      (acc, row) => acc + parseFloat(row.total_amt || 0),
      0
    );

    setFormData((prevData) => ({
      ...prevData,
      total: totalAmount.toFixed(2),
    }));
  };

  // Handle key press event
  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      const lastRow = formData.product[formData.product.length - 1];
      if (
        lastRow.product_id &&
        lastRow.qty &&
        lastRow.unit &&
        lastRow.price_unit &&
        lastRow.total_amt
      ) {
        handleAddRow();
      } else {
        toast.error(
          "Please fill in all fields in the last row before adding a new row"
        );
      }
    }
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    var updatedFormData = { ...formData };

    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        product: formData.product.map((row, index) =>
          index === rowIndex ? { ...row, [fieldName]: value } : row
        ),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }

    updatedFormData.product.forEach((row, index) => {
      const qty = parseFloat(row.qty);
      const price = parseFloat(row.price_unit);
      const discountPercentage = parseFloat(row.discount_percentage);
      const discountInputAmount = parseFloat(row.discount_amt);
      const taxPercentage = parseFloat(row.tax_percentage);
      const taxtype = row.tax_type;
      let sgst = 0,
        cgst = 0,
        igst = 0;

      let crtdiscountFiled = 0.0;

      let subtotal = isNaN(qty) || isNaN(price) ? 0 : qty * price;
      if (fieldName === "price_unit") {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : isNaN(subtotal)
          ? 0
          : (subtotal * discountPercentage) / 100;

        updatedFormData.product[index].discount_amt = crtdiscountFiled;
      }
      if (fieldName === "discount_percentage") {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : isNaN(subtotal)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.product[index].discount_amt = crtdiscountFiled;
      } else if (fieldName === "discount_amt") {
        crtdiscountFiled = isNaN(discountInputAmount) ? 0 : discountInputAmount;
        const cal = (crtdiscountFiled / subtotal) * 100;
        updatedFormData.product[index].discount_percentage = isNaN(cal)
          ? 0
          : parseFloat(cal).toFixed(2);
      }
      let tmpsubtotal = 0;
      if (fieldName === "tax_percentage") {
        tmpsubtotal =
          subtotal - (isNaN(discountInputAmount) ? 0 : discountInputAmount);
      } else {
        tmpsubtotal =
          subtotal - (isNaN(crtdiscountFiled) ? 0 : crtdiscountFiled);
      }

      console.log("siva", tmpsubtotal);
      console.log("siva tax", taxPercentage);
      console.log("siva disper", discountPercentage);
      console.log("discountInputAmount", discountInputAmount);
      console.log("subtotal", subtotal);
      console.log("crtdiscountFiled", crtdiscountFiled);
      let taxAmount =
        isNaN(tmpsubtotal) || isNaN(taxPercentage)
          ? 0
          : (tmpsubtotal * taxPercentage) / 100;
      let finalAmount = tmpsubtotal + taxAmount;
      if (taxtype === "IGST") {
        igst = taxAmount;
      } else {
        var gstamount = taxAmount / 2;
        cgst = gstamount;
        sgst = gstamount;
      }

      updatedFormData.product[index].tax_amt = taxAmount.toFixed(2);
      updatedFormData.product[index].total_amt = finalAmount.toFixed(2);
    });
    const totalAmount = updatedFormData.product.reduce(
      (acc, row) => acc + parseFloat(row.total_amt || 0),
      0
    );
    updatedFormData.total = totalAmount.toFixed(2);

    setFormData(updatedFormData);
  };

  // const handleGSTChange = async (e) => {
  //   const gstNumber = e.target.value.trim();

  //   // Update formData state with entered GST number
  //   setFormData({ ...formData, purchase_gst: gstNumber });

  //   // GST number should be exactly 15 characters
  //   if (gstNumber.length === 15) {
  //     try {
  //       const response = await axios.get(
  //         `https://api.mastergst.com/gst/${gstNumber}`, // Replace with real API endpoint
  //         {
  //           headers: {
  //             Authorization: "Bearer YOUR_API_KEY", // Replace with your actual API key
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (response.data) {
  //         const updatedFormData = {
  //           ...formData,
  //           partyname: response.data.tradeName || "",
  //           partyaddress: response.data.address || "",
  //           placeofsupply: response.data.state || "",
  //         };
  //         setFormData(updatedFormData);
  //       } else {
  //         alert("Invalid GST Number. No data found.");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching GST details:", error);
  //       alert(
  //         `Unable to fetch GST details. Error: ${
  //           error.response?.data?.message || error.message
  //         }`
  //       );
  //     }
  //   } else {
  //     // alert("Please enter a valid 15-character GST Number.");
  //   }
  // };

  function calculateTax(product, tax_percentage, index, taxType) {
    if (!tax_percentage) {
      console.error("Tax percentage is undefined for product:", product);
      return;
    }

    let updatedFormData = { ...formData };
    let sgst = 0,
      cgst = 0,
      igst = 0;

    let producttotal = parseFloat(product.total_amt) || 0;

    // ✅ Ensure tax_percentage is a string and has a valid format
    const taxValue = tax_percentage.match(/\d+\.*\d*/);
    if (!taxValue) {
      console.error("Invalid tax percentage format:", tax_percentage);
      return;
    }

    let taxAmt = (producttotal * parseFloat(taxValue[0])) / 100;

    if (taxType === "GST") {
      var taxAmount = taxAmt / 2;
      sgst = taxAmount;
      cgst = taxAmount;
    } else if (taxType === "IGST") {
      igst = taxAmt;
    }

    updatedFormData.product[index].SGST = sgst.toFixed(2);
    updatedFormData.product[index].CGST = cgst.toFixed(2);
    updatedFormData.product[index].IGST = igst.toFixed(2);
    updatedFormData.product[index].tax_type = taxType;

    setFormData(updatedFormData);
  }

  useEffect(() => {
    calculateTotal(formData.product);
  }, [formData.product]);

  useEffect(() => {
    const updateBalance = () => {
      const final_total = parseFloat(formData.final_total);
      const paid = parseFloat(formData.paid);

      const balance_amount =
        !isNaN(final_total) && !isNaN(paid) ? final_total - paid : "";

      setFormData((prevFormData) => ({
        ...prevFormData,
        balance_amount: balance_amount.toString(),
      }));
    };

    updateBalance();
  }, [formData.final_total, formData.paid]);

  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [productData, setProductData] = useState([]);
  const [partySalesData, setPartySalesData] = useState([]);
  const fetchPartySalesData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log("mk", responseData);
      setLoading(false);
      if (responseData.code === 200) {
        setPartySalesData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    fetchPartySalesData(); // Call fetchData directly in useEffect
  }, []);
  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const companyId = localStorage.getItem("companyId");
        const response = await fetch(
          `${API_DOMAIN}/products.php?id=${companyId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              search_text: "",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        setLoading(responseData);

        if (responseData.status === 200) {
          setProductData(responseData.data);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading();
        console.error("Error fetching data:", error.message);
      }
    };

    fetchProductData(); // Call fetchData directly in useEffect
  }, []);
  const [UnitData, setUnitData] = useState([]);
  const fetchUnitData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();

      setLoading(false);
      if (responseData.status === 200) {
        setUnitData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchUnitData(); // Call fetchData directly in useEffect
  }, []);
  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSubmit = async () => {
    try {
      const sanitizedFormData = {
        ...formData,
        roundoffAmount: isNaN(parseFloat(formData.roundoffAmount))
          ? "0.00"
          : parseFloat(formData.roundoffAmount).toFixed(2), // ✅ Ensure valid decimal
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || 0,
          tax_percentage: product.tax_percentage || 0,
        })),
      };

      console.log("Submitting Form Data:", sanitizedFormData);

      if (!navigator.onLine) {
        // 🌐 OFFLINE: Save the invoice data to IndexedDB
        const offlineInvoice = {
          invoice_id: Date.now(), // Temporary ID for offline
          ...sanitizedFormData,
        };

        await db.invoices.add(offlineInvoice);
        toast.info("Invoice saved offline. It will sync when online.", {
          style: { background: "#0f6159", color: "#fff" },
        });
      } else {
        // 🌍 ONLINE: Send to the server
        const response = await fetch(`${API_DOMAIN}/wholesale_invoice.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sanitizedFormData),
        });

        const responseData = await response.json();

        if (responseData.status === 200) {
          setFormData(initialState); // Reset form after successful submission
          successAlert(responseData.msg);
          setTimeout(() => {
            navigate("/console/wholesale"); // Navigate to wholesale page
          }, 2000);
        } else {
          toast.error(responseData.msg || "Error submitting invoice");
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      const sanitizedFormData = {
        ...formData,
        update_wholesale_id: rowData.invoice_id,
        roundoffAmount: isNaN(parseFloat(formData.roundoffAmount))
          ? "0.00"
          : parseFloat(formData.roundoffAmount).toFixed(2),
        product: formData.product.map((product) => ({
          ...product,
          tax_amt: product.tax_amt || 0,
          tax_percentage: product.tax_percentage || 0,
        })),
      };

      console.log("Submitting Updated Form Data:", sanitizedFormData);

      if (!navigator.onLine) {
        // 🌐 OFFLINE MODE: Store the update request in IndexedDB
        const offlineInvoiceUpdate = {
          invoice_id: rowData.invoice_id, // Keep the same ID for updates
          ...sanitizedFormData,
          isUpdate: true, // Mark this as an update request
        };

        await db.invoices.add(offlineInvoiceUpdate);
        toast.info("Invoice update saved offline. It will sync when online.", {
          style: { background: "#0f6159", color: "#fff" },
        });
      } else {
        // 🌍 ONLINE MODE: Send the update request to the server
        const response = await fetch(`${API_DOMAIN}/wholesale_invoice.php`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(sanitizedFormData),
        });

        const responseData = await response.json();

        if (responseData.status === 200) {
          toast.success("Wholesale Bill updated successfully!", {
            position: "top-center",
            autoClose: 2000,
            theme: "colored",
          });
          setTimeout(() => {
            navigate("/console/wholesale");
          }, 2000);
        } else {
          console.error(
            responseData.msg || "Unknown error occurred during update"
          );
        }
      }
    } catch (error) {
      console.error("Error updating product:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    });
  });

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check session logic here, e.g., fetch from local storage or server
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  //console.log("partySalesData", partySalesData);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return (
    <>
      <div>
        <div className="main stick-top">
          <Container fluid>
            <Row>
              <Col lg="12">
                <PageHead
                  pagehead={<>Wholesale Bill</>}
                  onClick={() => navigate(-1)}
                />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="main my-3">
          <div>
            <Container fluid>
              <Row>
                <Col lg="12">
                 <Table className="mobile-float-none">
  <tbody>
    <tr>
      <td className="mobile-float-none">
        {/* Row 1: Stacks one by one on mobile */}
        <div className="d-flex mobile-flex-column">
          <div className="w-20 m-3 mobile-w-100">
            <DropDownUI
              optionlist={partySalesData.map((user) => ({
                value: user.party_id,
                label: user.party_name,
              }))}
              placeholder="Party Name"
              labelname="Party Name"
              name="party_name"
              value={formData.party_id}
              onChange={(selectedValue) => {
                 console.log(
                                  "Selected Party ID:",
                                  selectedValue
                                );
                const selectedParty = partySalesData.find(
                  (party) => party.party_id === selectedValue.party_name
                );
                if (selectedParty) {
                  setFormData({
                    ...formData,
                    party_id: selectedParty.party_id,
                    partyname: selectedParty.party_name,
                    partyaddress: selectedParty.billing_address,
                    purchasemobile_no: selectedParty.mobile_number,
                    purchase_gst: selectedParty.gst_no,
                    placeofsupply: selectedParty.city,
                  });
                }
              }}
            />
          </div>

          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"Party Address"}
              labelname={"Party Address"}
              name="partyaddress"
              value={formData.partyaddress}
              onChange={(e) => handleChange(e, "partyaddress")}
            />
          </div>

          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"Place Of Supply"}
              labelname={"Place Of Supply"}
              name="placeofsupply"
              value={formData.placeofsupply}
              onChange={(e) => handleChange(e, "placeofsupply")}
            />
          </div>

            {/* <div className="w-20 m-3">
                            <TextInputForm
                              placeholder={"Party GST"}
                              labelname={"Party GST"}
                              name="purchase_gst"
                              value={formData.purchase_gst}
                              onChange={(e) => handleGSTChange(e)}
                            />
                          </div> */}

          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"Party GST"}
              labelname={"Party GST"}
              name="purchase_gst"
              value={formData.purchase_gst}
              onChange={(e) => handleChange(e, "purchase_gst")}
            />
          </div>

          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"R.R/L.R.NO."}
              labelname={"R.R/L.R.NO."}
              name="receipt_number"
              value={formData.receipt_number}
              onChange={(e) => handleChange(e, "receipt_number")}
            />
          </div>
        </div>

        {/* Row 2: Stacks one by one on mobile */}
        <div className="d-flex mobile-flex-column">
          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"Transport GST No"}
              labelname={"Transport GST No"}
              name="transport_gst_no"
              value={formData.transport_gst_no}
              onChange={(e) => handleChange(e, "transport_gst_no")}
            />
          </div>
          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"PartyMobileNumber"}
              labelname={"PartyMobileNumber"}
              name="purchasemobile_no"
              value={formData.purchasemobile_no}
              onChange={(e) => handleChange(e, "purchasemobile_no")}
            />
          </div>
          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"Despatched By"}
              labelname={"Despatched By"}
              name="despatched_by"
              value={formData.despatched_by}
              onChange={(e) => handleChange(e, "despatched_by")}
            />
          </div>
          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"From"}
              labelname={"From"}
              name="from"
              value={formData.from}
              onChange={(e) => handleChange(e, "from")}
            />
          </div>
          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"To"}
              labelname={"To"}
              name="to"
              value={formData.to}
              onChange={(e) => handleChange(e, "to")}
            />
          </div>
        </div>

        {/* Row 3: Stacks one by one on mobile */}
        <div className="d-flex mobile-flex-column">
          <div className="w-20 m-3 mobile-w-100">
            <TextInputForm
              placeholder={"Total"}
              labelname={"Total"}
              name="total_cases"
              value={formData.total_cases}
              onChange={(e) => handleChange(e, "total_cases")}
            />
          </div>
        </div>
      </td>

      {/* Invoice Section: mobile-float-none moves it from far-right to left-stack on mobile */}
      <td className="mx-auto float-end mobile-float-none mobile-w-100">
        <div className="m-3">
          <TextInputForm
            placeholder={"Invoice Number"}
            labelname={"Invoice Number"}
            name="bill_no"
            value={formData.bill_no}
            onChange={(e) => handleChange(e, "bill_no")}
          />
        </div>
        <div className="m-3">
          <Calender
            setLabel={(date) => setLabel(date, "bill_date")}
            selectedDate={formData.bill_date}
            calenderlabel="BillDate"
          />
        </div>
      </td>
    </tr>
  </tbody>
</Table>
                </Col>
                <Col lg="12" className="py-3">
                  <div>
                    No Of Products :{" "}
                    <span>{formData?.product?.length || 0}</span>
                  </div>
                </Col>
               <Col lg="12" md="6" xs="12">
  <div className="py-2 category-table bill">
    {/* Wrap Table in table-responsive to trigger the media query scroll */}
    <div className="table-responsive">
      <Table>
        <thead>
          <tr>
            <th rowSpan={2} className="wrdbrk w-4 text-nowrap">
              Marks & No.
            </th>
            {/* Added mobile-col-width (will be 200px based on your CSS nth-child rule) */}
            <th rowSpan={2} className="wrdbrk w-18 text-nowrap mobile-col-width">
              Product Name
            </th>
            <th rowSpan={2} className="wrdbrk w-5 text-nowrap">
              Qty
            </th>
            <th rowSpan={2} className="wrdbrk w-10 text-nowrap">
              Per
            </th>
            {/* Added mobile-col-width (will be 150px based on your CSS) */}
            <th rowSpan={2} className="wrdbrk w-7 text-nowrap mobile-col-width">
              Price / Unit
            </th>
            <th colSpan={2} className="wrdbrk w-15 text-nowrap">
              Discount
            </th>
             {/* <th colSpan={2} className="wrdbrk w-15">
                            Tax
                          </th> */}

            <th rowSpan={2} className="wrdbrk w-10 text-nowrap mobile-col-width">
              Amount
            </th>
            <th rowSpan={2} className="wrdbrk w-10"></th>
          </tr>
          <tr>
                   {/* <th>%</th>
                          <th className="w-10">Amount</th> */}
            <th className="w-5 text-nowrap">%</th>
            <th className="w-10 text-nowrap">Amount</th>
          </tr>
        </thead>
        <tbody>
          {formData.product &&
            formData.product.map((row, index) => (
              <tr key={index}>
                <td>
                  <TextInputForm
                    placeholder={"No"}
                    name="Marks & No"
                    value={row.MarksNo}
                    onChange={(e) => handleChange(e, "MarksNo", index)}
                    onKeyDown={(e) => handleKeyPress(e, index)}
                  />
                </td>
                {/* Product Name Cell */}
                <td className="mobile-col-width">
                  <div>
                    <DropDownUI
                      optionlist={productData.map((user) => ({
                        value: user.product_id,
                        label: user.product_name,
                      }))}
                      placeholder="ProductName"
                      name="product_id"
                      value={row.product_id}
                      onChange={(updatedFormData) => {
                        const selectedProduct = productData.find(
                          (user) => user.product_id === updatedFormData.product_id
                        );
                        setFormData({
                          ...formData,
                          product: formData.product.map((r, i) =>
                            i === index
                               ? {
                                                ...r,
                                                product_id:
                                                  updatedFormData.product_id,
                                                hsn_no: selectedProduct
                                                  ? selectedProduct.hsn_no
                                                  : "", // Set price_unit from unit_rate
                                                product_name: selectedProduct
                                                  ? selectedProduct.product_name
                                                  : "",
                                              }
                                            : r
                          ),
                        });
                      }}
                      onKeyDown={(e) => handleKeyPress(e, index)}
                      autoFocus={index === formData.product.length - 1}
                    />
                  </div>
                  <div className="mt-1">
                    <TextInputForm
                      placeholder={"Remarks"}
                      name="remark"
                      value={row.remark}
                      onChange={(e) => handleChange(e, "remark", index)}
                      onKeyDown={(e) => handleKeyPress(e, index)}
                    />
                  </div>
                </td>
                <td>
                  <TextInputForm
                    placeholder={"qty"}
                    name="qty"
                    value={row.qty}
                    onChange={(e) => handleChange(e, "qty", index)}
                    onKeyDown={(e) => handleKeyPress(e, index)}
                  />
                </td>
                <td>
                  <DropDownUI
                    optionlist={UnitData.map((user) => ({
                      value: user.unit_id,
                      label: user.unit_name,
                    }))}
                    placeholder="Unit"
                    name="unit"
                    value={row.unit}
                    onChange={(updatedFormData) =>
                      setFormData({
                        ...formData,
                        product: formData.product.map((r, i) =>
                          i === index ? { ...r, unit: updatedFormData.unit } : r
                        ),
                      })
                    }
                    onKeyDown={(e) => handleKeyPress(e, index)}
                  />
                </td>
                {/* Price Cell */}
                <td className="mobile-col-width">
                  <TextInputForm
                    placeholder={"price"}
                    name="price"
                    value={row.price_unit}
                    onChange={(e) => handleChange(e, "price_unit", index)}
                    onKeyDown={(e) => handleKeyPress(e, index)}
                  />
                </td>
                <td>
                  <TextInputForm
                    placeholder={"%"}
                    name="discount_percentage"
                    value={row.discount_percentage}
                    onChange={(e) => handleChange(e, "discount_percentage", index)}
                    onKeyDown={(e) => handleKeyPress(e, index)}
                    disabled={formData.discount_all}
                  />
                </td>
                <td>
                   <TextInputForm
                                  placeholder={"discount_amt"}
                                  name="discount_amt"
                                  value={row.discount_amt}
                                  onChange={(e) =>
                                    handleChange(e, "discount_amt", index)
                                  }
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                  disabled={formData.total_discountall}
                                />
                </td>
                 {/* <td>
                                <TextInputForm
                                  placeholder={"tax_amt"}
                                  name="tax_amt"
                                  value={row.tax_amt}
                                  onChange={(e) =>
                                    handleChange(e, "tax_amt", index)
                                  }
                                  onKeyDown={(e) => handleKeyPress(e, index)}
                                />
                              </td> */}
                {/* Total Amount Cell */}
                <td className="mobile-col-width">
                  <TextInputForm
                    placeholder={"amt"}
                    name="total_amt"
                    value={row.total_amt}
                    onChange={(e) => handleChange(e, "total_amt", index)}
                    onKeyDown={(e) => handleKeyPress(e, index)}
                  />
                </td>
                 <td className="d-none">
                                <div className="d-none">
                                  {index === formData.product.length - 1 && (
                                    <ClickButton
                                      label={<>Add More</>}
                                      onClick={handleAddRow}
                                    />
                                  )}
                                </div>
                              </td>
                <td>
                  <Delete
                    onClick={() => handleDeleteRow(index)}
                    label={<MdDeleteForever />}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  </div>
</Col>
              </Row>
            </Container>
          </div>
          <div className="my-3">
           <Container>
  <Row>
    <Col lg="5">{/* <PayMents /> */}</Col>
    <Col lg="7">
      <div className="inside my-3">
        {/* Step 1: Wrap the table in table-responsive */}
        <div className="table-responsive">
          <Table className="table table-bordered align-middle">
            <tbody>
              {/* Total Row */}
              <tr>
                <td className="fw-bold text-nowrap">Sub Total</td>
                <td></td>
                <td className="w-25 text-end">
                  <div className="mobile-input-width">
                    <TextInputForm
                      placeholder={"Total"}
                      name="total"
                      value={formData.total}
                      onChange={handlePaidChange}
                    />
                  </div>
                </td>
              </tr>

              {/* GST Selection */}
              <tr>
                <td className="fw-bold text-nowrap">
                  GST (Apply to All Products)
                </td>
                <td></td>
                <td className="w-25 text-end">
                  <div className="mobile-input-width">
                    <DropDownUI
                      optionlist={alltax}
                      placeholder="Select GST"
                      name="globalGST"
                      value={formData.globalGST}
                      onChange={(updatedFormData) =>
                        handleGlobalGST(updatedFormData)
                      }
                    />
                  </div>
                </td>
              </tr>

              {/* GST Amount Row */}
              <tr>
                <td className="fw-bold text-nowrap">GST Amount</td>
                <td></td>
                <td className="w-25 text-end">
                  {parseFloat(formData.taxover_amt || 0).toFixed(2)}
                </td>
              </tr>

              {/* Subtotal Row */}
              <tr>
                <td className="fw-bold text-nowrap">Total (Incl. GST)</td>
                <td></td>
                <td className="w-25 text-end">
                  {parseFloat(formData.final_total || 0).toFixed(2)}
                </td>
              </tr>

              <tr>
                <td className="fw-bold text-nowrap">Round Off</td>
                <td></td>
                <td className="w-25 text-end">
                  <input
                    type="checkbox"
                    checked={roundoff}
                    onChange={handleRoundoffChange}
                  />
                </td>
              </tr>

              {/* Roundoff Amount Row */}
              <tr>
                <td className="fw-bold text-nowrap">Roundoff Amount</td>
                <td></td>
                <td className="w-25 text-end">
                  {parseFloat(formData.roundoffAmount || 0).toFixed(2)}
                </td>
              </tr>

              {/* Paid Row */}
              <tr>
                <td className="fw-bold text-nowrap">Paid</td>
                <td></td>
                <td className="w-25 text-end">
                  <div className="mobile-input-width">
                    <TextInputForm
                      placeholder={"Paid"}
                      name="paid"
                      value={formData.paid}
                      onChange={handlePaidChange}
                    />
                  </div>
                </td>
              </tr>

              {/* Balance Row */}
              <tr>
                <td className="fw-bold text-nowrap">Balance</td>
                <td></td>
                <td className="w-25 text-end">
                  <div className="mobile-input-width">
                    <TextInputForm
                      placeholder={"Balance"}
                      name="balance_amount"
                      value={formData.balance_amount}
                      onChange={handlePaidChange}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </Col>
  </Row>
</Container>
          </div>
        </div>
        <div className="main stick-bottom">
          <div className="w-50 ms-auto">
            <Container>
              <Row>
                <Col lg="12">
                  <div className="text-center">
                    {type === "edit" ? (
                      <>
                        <ToastContainer
                          position="bottom-center"
                          autoClose={3000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="light"
                          style={{ marginTop: "60px" }}
                        />
                      
<div className="mobile-button">
                        <span className="mx-2">
                          <ClickButton
                            label={<>Update</>}
                            onClick={handleUpdateSubmit}
                          ></ClickButton>
                        </span>

                        <span className="mx-2">
                          <ClickButton
                            label={<>Cancel</>}
                            onClick={() => navigate("/console/wholesale")}
                          ></ClickButton>
                        </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <ToastContainer
                          position="bottom-center"
                          autoClose={3000}
                          hideProgressBar={false}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="light"
                          style={{ marginTop: "60px" }} // Adjust the value as needed
                        />
<div className="mobile-button">
                        <span className="mx-2">
                          <ClickButton
                            label={<>Submit</>}
                            onClick={handleSubmit}
                          ></ClickButton>
                        </span>

                        <span className="mx-2">
                          <ClickButton
                            label={<>Cancel</>}
                            onClick={() => navigate("/console/wholesale")}
                          ></ClickButton>
                        </span>
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export { WholesaleBillEntry };

//<td className="w-10 text-left">
// <DropDownUI
// optionlist={alltax}
//   placeholder="Tax"
//   name="tax_percentage"
//   value={row.tax_percentage}
//   onChange={(updatedFormData) => {
//     const selectedTax = alltax.find(
//       (tax) => tax.value === updatedFormData.tax_percentage
//     );
//     console.log("selecedtax", selectedTax);
//     const taxType = selectedTax ? selectedTax.value.split("@")[0] : "";
//     console.log("taxtype", taxType);
//     settax_type(taxType);
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       product: prevFormData.product.map((r, i) =>
//         i === index
//           ? {
//               ...r,
//               tax_percentage: updatedFormData.tax_percentage,
//             }
//           : r
//       ),
//     }));
//     calculateTax(
//       formData.product[index],
//       updatedFormData.tax_percentage,
//       index,
//       taxType
//     );
//     handleChange(
//       {
//         value: parseFloat(
//           updatedFormData.tax_percentage.match(/\d+\.*\d*/)[0]
//         ),
//       },
//       "tax_percentage",
//       index
//     );
//     //handleChange({ value: updatedFormData.taxType}, 'tax_type', index);
//   }}
//   onKeyDown={(e) => handleKeyPress(e, index)}
// />
// </td>;
